<template>
    <div class="container py-4">
  
      <!-- Boutons en haut à gauche -->
      <div class="d-flex justify-content-start mb-4">
        <a
          :href="this.$store.getters.apiUrl+`/artisan/${user.slug}`"
          target="_blank"
          class="btn btn-outline-primary me-2"
          title="Voir la page"
        >
          <i class="fas fa-eye"></i>
        </a>
  
        <button class="btn btn-outline-warning me-2" @click="editUser" title="Modifier">
          <i class="fas fa-edit"></i>
        </button>
  
        <button class="btn btn-outline-danger" @click="deleteUser" title="Supprimer">
          <i class="fas fa-trash-alt"></i>
        </button>
      </div>
  
      <!-- Détails utilisateur -->
      <div class="card shadow-sm">
        <div class="card-body row">
  
          <!-- Photo -->
          <div class="col-md-3 text-center mb-3">
            <img :src="user.photo_url" alt="Photo de profil" class="img-fluid rounded-circle shadow" style="max-width: 150px;">
          </div>
  
          <!-- Infos -->
          <div class="col-md-9">
            <h4 class="mb-1">{{ user.name }}</h4>
            <p class="text-muted">{{ user.email }}</p>
  
            <div class="mb-2">
              <strong>Prénom :</strong> {{ user.prenom }}<br>
              <strong>Nom :</strong> {{ user.nom }}
            </div>
  
            <div class="mb-2">
              <strong>Téléphone :</strong> {{ user.telephone }}<br>
              <strong>Adresse :</strong> {{ user.adresse }}
            </div>
  
            <div class="mb-2">
              <strong>Ville :</strong>
              <span class="badge bg-info text-dark">{{ user.ville }}</span>
            </div>
  
            <div class="mb-2">
              <strong>Métiers :</strong>
              <ul class="mb-0">
                <li v-if="user.metier">{{ user.metier }}</li>
                <li v-if="user.metier_deux">{{ user.metier_deux }}</li>
                <li v-if="user.metier_trois">{{ user.metier_trois }}</li>
                <li v-if="user.metier_quatre">{{ user.metier_quatre }}</li>
                <li v-if="user.metier_cinq">{{ user.metier_cinq }}</li>
              </ul>
            </div>
  
            <div class="mb-2">
              <strong>Expérience :</strong> {{ user.experience }} an(s)<br>
              <strong>Étoiles :</strong> {{ user.etoiles }} / 5 ⭐
            </div>
  
            <div class="mb-2">
              <strong>Inscrit à la newsletter :</strong>
              <span :class="user.newsletter ? 'text-success' : 'text-danger'">
                {{ user.newsletter ? 'Oui' : 'Non' }}
              </span>
            </div>
  
            <div class="mb-2">
              <strong>Email vérifié :</strong>
              {{ user.email_verified_at ? new Date(user.email_verified_at).toLocaleString() : 'Non vérifié' }}
            </div>
  
            <div class="mb-2">
              <strong>Bio :</strong><br>
              <p class="text-muted">{{ user.bio }}</p>
            </div>
  
            <div class="mb-2">
              <strong>Liens :</strong><br>
              <a :href="user.linkedin" target="_blank" v-if="user.linkedin" class="me-3 text-decoration-none">
                <i class="fab fa-linkedin text-primary"></i> LinkedIn
              </a>
              <a :href="user.portfolio" target="_blank" v-if="user.portfolio" class="text-decoration-none">
                <i class="fas fa-globe text-success"></i> Portfolio
              </a>
            </div>
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script >
  import { defineComponent } from 'vue';
  import $ from 'jquery'
  import FormUser from './FormUser.vue';
  
  export default defineComponent({
    name: 'ShowUser',
    inject: ['dialogRef'],
    data() {
      return {
        isLoading: false,
        table: 'users',
        user: this.dialogRef?.data
      };
    },
    methods: {
      editUser() {
        this.dialogRef.close()
            this.$dialog.open(FormUser, {
                props: {
                    header: 'Modifier artisan '+ this.user.name,
                    style: { width: '80vw' },
                    modal: true,
                },
                data: this.user
            });
      },
      deleteUser() {
        //demander une confirmation avant de supprimer
        if (!window.confirm("Etes vous sur de vouloir supprimer ?")) {
                return
            }
            this.isLoading = true
            this.axios.post('/api/utilisateurs/' + this.user.id + '/destroy').then((response) => {
                this.isLoading = false
                if (response.data.success === true) {
                    $('#refresh' + this.table).click()
                    this.dialogRef.close()
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message,
                        life: 3000
                    });
                }
                else {
                    response.data.errors.forEach(element => {
                        this.$toast.add({
                            severity: 'warn',
                            summary: 'Oups !',
                            detail: element,
                            life: 20000
                        });
                    });
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
      }
    }
  });
  </script>
  
  <style scoped>
  img {
    max-height: 150px;
    object-fit: cover;
  }
  </style>
  